import React from "react";
import { useEffect, useState } from 'react';
import ScrollToTopButton from '../Shared/ScrollToTopButton';
import staffPath from 'assets/files/application-for-employment-staff.pdf';
import operationalPath from 'assets/files/application-for-employment-operational.pdf';
import monitoringPath from 'assets/files/equal-opportunities-monitoring-form.pdf';
import { Col, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";

function ActiveJobListings(props) {

    const onDownloadApplication = (jobType, e) => {
        e.preventDefault();

        const url = jobType === "Staff"
            ? staffPath
            : operationalPath

        fetch(url).then(response => {
            response.blob().then(blob => {
                const fileURL = window.URL.createObjectURL(blob);
                let alink = document.createElement('a');
                alink.href = fileURL;
                alink.download = 'FPM Application Form.pdf';
                alink.click();
            });
        });
    };


    const onDownloadMonitoring = (e) => {
        e.preventDefault();

        fetch(monitoringPath).then(response => {
            response.blob().then(blob => {
                const fileURL = window.URL.createObjectURL(blob);
                let alink = document.createElement('a');
                alink.href = fileURL;
                alink.download = 'FPM - Equal Opportunities Monitoring Form.pdf';
                alink.click();
            });
        });
    };


    //function onDownloadJobSpec(base64Data, fileName) {
    //    const byteCharacters = atob(base64Data);
    //    const byteNumbers = new Array(byteCharacters.length);
    //    for (let i = 0; i < byteCharacters.length; i++) {
    //        byteNumbers[i] = byteCharacters.charCodeAt(i);
    //    }
    //    const byteArray = new Uint8Array(byteNumbers);
    //    const blob = new Blob([byteArray], { type: "application/octet-stream" });

    //    const fileURL = window.URL.createObjectURL(blob);
    //    const downloadLink = document.createElement("a");
    //    downloadLink.href = fileURL;
    //    downloadLink.download = fileName;
    //    downloadLink.click();
    //}


    function onDownloadJobSpec(base64String, filename) {
        const byteCharacters = atob(base64String);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const extension = filename.substring(filename.lastIndexOf('.') + 1);
        const mimeType = getMimeType(extension);

        if (!mimeType) {
            console.error('Unsupported file format');
            return;
        }

        const blob = new Blob([byteArray], { type: mimeType });

        const fileURL = window.URL.createObjectURL(blob);
        const aLink = document.createElement('a');
        aLink.href = fileURL;
        aLink.download = filename;
        aLink.click();
    }

    function getMimeType(extension) {
        switch (extension.toLowerCase()) {
            case 'pdf':
                return 'application/pdf';
            case 'doc':
                return 'application/msword';
            case 'docx':
                return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
            default:
                return null;
        }
    }

    const handleShare = (shareType, jobTitle, e) => {
        e.preventDefault();

        const shareMessage = {
            title: `Check out the ${jobTitle} role at FPMcCann`,
            description: 'Exciting opportunity to join our team and make a difference!',
            url: 'https://apps.fpmccann.co.uk/FPMCareers', // URL of shared website
        };

        if (shareType === 'linkedin') {
            const shareURL = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareMessage.url)}`;
            window.open(shareURL, '_blank');
        } else if (shareType === 'facebook') {
            const shareURL = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareMessage.url)}`;
            window.open(shareURL, '_blank');
        } else if (shareType === 'email') {
            const subject = `Check out the ${jobTitle} role at FPMcCann`;
            const body = `Hi,\n\nI wanted to share an exciting opportunity to join our team at FPMcCann.\n\nTitle: ${jobTitle}\n\nDescription: ${shareMessage.description}\n\nApply here: ${shareMessage.url}`;
            const mailtoURL = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
            window.location.href = mailtoURL;
        } else if (shareType === 'twitter') {
            const text = `Check out the ${jobTitle} role at FPMcCann. Exciting opportunity to join our team and make a difference! ${shareMessage.url}`;
            const shareURL = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}`;
            window.open(shareURL, '_blank');
        }
    };

    function renderJobItem(x, handleShare, onDownloadJobSpec, onDownloadApplication, onDownloadMonitoring) {
        return (
            <Col xs={12} md={4} className="list-item-cv mb-md-1">
                <div className="mb-0 p-2">
                    <div className="item">
                        <div className="header">
                            <h5>{x.jobType}</h5>

                            <div className="share-icons">
                                <div className="icon hover-icon">
                                    <i className="fas fa-share-alt"></i>
                                    <div className="hover-content">
                                        <a href="#" title="Share via Email" onClick={(e) => handleShare('email', x.jobTitle, e)}>
                                            <i className="fas fa-envelope"></i>
                                        </a>
                                        <a href="#" title="Share on Facebook" onClick={(e) => handleShare('facebook', x.jobTitle, e)} >
                                            <i className="fab fa-facebook"></i>
                                        </a>
                                        <a href="#" title="Share on Twitter" onClick={(e) => handleShare('twitter', x.jobTitle, e)}>
                                            <i className="fab fa-twitter"></i>
                                        </a>
                                        <a href="#" title="Share on Linkedin" onClick={(e) => handleShare('linkedin', x.jobTitle, e)} >
                                            <i className="fab fa-linkedin-in"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <h2 className="title" style={{ marginTop: "10px" }}>
                            {x.jobTitle}
                        </h2>
                        <div className="location">
                            <p>{x.location}</p>
                        </div>
                        <div className="list-feature">
                            <div className="icon">
                                <svg
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M12 16L16 11H13V4H11V11H8L12 16Z"
                                        fill="#00384B"
                                    />
                                    <path
                                        d="M20 18H4V11H2V18C2 19.103 2.897 20 4 20H20C21.103 20 22 19.103 22 18V11H20V18Z"
                                        fill="#00384B"
                                    />
                                </svg>
                                <a
                                    className="downloadlink"

                                    onClick={() => {
                                        if (x.jobSpecDocument) {
                                            onDownloadJobSpec(
                                                x.jobSpecDocument,
                                                x.jobSpecDocumentFileName
                                            );
                                        }
                                    }}
                                >
                                    View Job Specification
                                </a>
                            </div>

                            {/*<div className="icon">*/}
                            {/*    <svg*/}
                            {/*        width={24}*/}
                            {/*        height={24}*/}
                            {/*        viewBox="0 0 24 24"*/}
                            {/*        fill="none"*/}
                            {/*        xmlns="http://www.w3.org/2000/svg"*/}
                            {/*    >*/}
                            {/*        <path*/}
                            {/*            d="M3 2H5V22H3V2ZM10 6H17V8H10V6ZM10 10H17V12H10V10Z"*/}
                            {/*            fill="#00384B"*/}
                            {/*        />*/}
                            {/*        <path*/}
                            {/*            d="M19 2H14H13.937H6V22H13.938H14H19C20.103 22 21 21.103 21 20V4C21 2.897 20.103 2 19 2ZM19 20H14H13.937H8V4H13.938H14H19V20Z"*/}
                            {/*            fill="#00384B"*/}
                            {/*        />*/}
                            {/*    </svg>*/}
                            {/*    <a*/}
                            {/*        href="#"*/}
                            {/*        className="downloadlink"*/}
                            {/*        rel="noopener noreferrer"*/}
                            {/*        style={{ textAlign: "start" }}*/}
                            {/*        onClick={(e) => onDownloadApplication(x.jobType, e)}*/}
                            {/*    >*/}
                            {/*        Application Form*/}
                            {/*    </a>*/}
                            {/*</div>*/}


                            {/*<div className="icon">*/}
                            {/*    <svg*/}
                            {/*        width={24}*/}
                            {/*        height={24}*/}
                            {/*        viewBox="0 0 24 24"*/}
                            {/*        fill="none"*/}
                            {/*        xmlns="http://www.w3.org/2000/svg"*/}
                            {/*    >*/}
                            {/*        <path*/}
                            {/*            d="M3 2H5V22H3V2ZM10 6H17V8H10V6ZM10 10H17V12H10V10Z"*/}
                            {/*            fill="#00384B"*/}
                            {/*        />*/}
                            {/*        <path*/}
                            {/*            d="M19 2H14H13.937H6V22H13.938H14H19C20.103 22 21 21.103 21 20V4C21 2.897 20.103 2 19 2ZM19 20H14H13.937H8V4H13.938H14H19V20Z"*/}
                            {/*            fill="#00384B"*/}
                            {/*        />*/}
                            {/*    </svg>*/}
                            {/*    <a*/}
                            {/*        href="#"*/}
                            {/*        className="downloadlink"*/}
                            {/*        rel="noopener noreferrer"*/}
                            {/*        style={{ textAlign: "start" }}*/}
                            {/*        onClick={(e) => onDownloadMonitoring(e)}*/}
                            {/*    >*/}
                            {/*        Monitoring Questionnaire*/}
                            {/*    </a>*/}
                            {/*</div>*/}


                            {/*<Link*/}
                            {/*    to={`/jobapplicationwizard/apply/${x.id}`}*/}
                            {/*    style={{ textDecoration: "none" }}*/}
                            {/*>*/}
                            {/*    <div className="list-feature">*/}
                            {/*        <button className="icon3" style={{ backgroundColor: "#48A15E", color: "#ffffff", padding: "5px 15px" }}>*/}
                            {/*            Apply Now*/}
                            {/*            <svg*/}
                            {/*                width={24}*/}
                            {/*                height={24}*/}
                            {/*                viewBox="0 0 24 24"*/}
                            {/*                fill="none"*/}
                            {/*                xmlns="http://www.w3.org/2000/svg"*/}
                            {/*            >*/}
                            {/*                <path*/}
                            {/*                    d="M11.293 17.293L12.707 18.707L19.414 12L12.707 5.293L11.293 6.707L15.586 11H6V13H15.586L11.293 17.293Z"*/}
                            {/*                    fill="#ffffff"*/}
                            {/*                />*/}
                            {/*            </svg>*/}
                            {/*        </button>*/}
                            {/*        </div>*/}


                            {/*</Link>*/}

                            <Link
                                to={`/jobapplicationwizard/apply/${x.id}`}
                                style={{ textDecoration: "none" }}
                            >
                                <div className="icon" >
                                    Apply Online
                                    <svg
                                        width={24}
                                        height={24}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M11.293 17.293L12.707 18.707L19.414 12L12.707 5.293L11.293 6.707L15.586 11H6V13H15.586L11.293 17.293Z"
                                            fill="#1DB4D7"
                                            className="downloadlink"
                                        />
                                    </svg>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
            </Col>
        );
    }


    return (
        <>
            {props.isLoading ? (
                <div className="text-center">
                    <Spinner
                        animation="border"
                        style={{
                            width: '200px',
                            height: '200px',
                            border: '9px solid #fff',
                            borderRadius: '50%',
                            borderTopColor: '#1abc9c',
                            fontSize: '60px',
                        }}
                    />
                    <h3>Loading Jobs...</h3>
                </div>
            ) : (
                <>
                    <div className="d-flex flex-column flex-md-row flex-wrap" id="loop-cv">
                        <div className="w-100"></div>
                        <Col xs={12} md={4} className="list-item-cv mb-md-1">
                            <div className="mb-0 p-2" >
                                <div className="item disable" >
                                    <div className="header"  >
                                        <h5>Join our Talent Network</h5>
                                    </div>
                                    <h2 className="title" style={{ marginTop: "0px" }}>
                                        Expression Of Interest
                                    </h2>
                                    <div className="location" style={{ marginTop: "0px", textTransform: "none" }}>
                                        <p style={{ fontSize: "18px", lineHeight: "1.6", textAlign: "start", marginTop: "-20px", textTransform: "none" }}>
                                            We're always looking for talented individuals to join our team.
                                            Register your interest in FP McCann by clicking on the button below.
                                        </p>
                                        <div style={{ margin: '42px 0' }}></div>
                                    </div>

                                    <div className="list-feature">
                                        <button className="icon2" onClick={() => {
                                            props.openModal();

                                            }} style={{ backgroundColor: "#48A15E", color: "#ffffff", padding: "5px 15px" }}>
                                            Express Interest
                                            <svg
                                                width={24}
                                                height={24}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M11.293 17.293L12.707 18.707L19.414 12L12.707 5.293L11.293 6.707L15.586 11H6V13H15.586L11.293 17.293Z"
                                                    fill="#ffffff"
                                                />
                                            </svg>
                                        </button>

                                    </div>
                                </div>
                            </div>
                        </Col>
                        {props.jobListings?.map((job, index) => (
                            <React.Fragment key={index}>
                                {index % 3 === 0 && index !== 0 && (
                                    <>
                                        <div className="w-100"></div>
                                        {renderJobItem(job, handleShare, onDownloadJobSpec, onDownloadApplication, onDownloadMonitoring)}
                                    </>
                                )}

                                {index !== 0 && index % 3 !== 0 && renderJobItem(job, handleShare, onDownloadJobSpec, onDownloadApplication, onDownloadMonitoring)}
                            </React.Fragment>
                        ))}
                        <ScrollToTopButton />
                    </div>

                </>
            )}

        </>
    );
}

export default ActiveJobListings;
